import { useSetAtom } from "jotai";
import { useEffect } from "react";
import {
  LocalMediaStatus,
  getStoredAudioVideoSettings,
  localAudioContextAtom,
  localVideoContextAtom,
  useConnectAudioVideoInputs,
} from "../../video-sdk";
import { useValidateStoredDeviceIdsCallback } from "../devices/useValidateStoredDeviceIdsCallback";
import { useResetLocalVideoOnScreenOrientationChange } from "../useResetLocalVideoOnScreenOrientationChange";

export function useInitLocalAudioVideoContext(isEnabled: boolean = true) {
  const connectAudioVideoInputs = useConnectAudioVideoInputs();
  // TODO CARED-2589: Adapt hook
  useResetLocalVideoOnScreenOrientationChange();
  const validateStoredDeviceIds = useValidateStoredDeviceIdsCallback();
  const setLocalAudioContext = useSetAtom(localAudioContextAtom);
  const setLocalVideoContext = useSetAtom(localVideoContextAtom);

  useEffect(
    function initTracksOnMount() {
      if (!isEnabled) return;

      // Initialize track states synchronously to prevent flash
      const { isAudioEnabled, isVideoEnabled } = getStoredAudioVideoSettings();

      // Set audio context
      setLocalAudioContext({
        status: isAudioEnabled
          ? LocalMediaStatus.LOADING
          : LocalMediaStatus.DISABLED,
      });

      // Set video context
      setLocalVideoContext({
        status: isVideoEnabled
          ? LocalMediaStatus.LOADING
          : LocalMediaStatus.DISABLED,
      });

      (async () => {
        await validateStoredDeviceIds();
        await connectAudioVideoInputs();
      })();
    },
    // We only want to run this effect once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
}
